import { createEffect } from "solid-js";
import { createMutable } from "solid-js/store";
export default function usePreviousProps(props, propNames) {
    const initialValue = propNames.reduce((result, name) => {
        result[name] = props[name];
        return result;
    }, {});
    const prevProps = createMutable(initialValue);
    for (const propName of propNames)
        createEffect((prev) => {
            prevProps[propName] = prev;
            return props[propName];
        }, props[propName]);
    return prevProps;
}
